<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="purple"
          title="جدول الإحالات"
          text="قائمة بعمليات الاحالات الى المستشفيات"
        >




          <v-data-table
                    :search="search"
                    :loading="isloading"
                    :loading-text="loadingtext"
                    :headers="headers"
                    :items="items"
                    ref="tbl"
          >

            <template v-slot:top>
              <v-toolbar flat color="white">


                <v-dialog v-model="newDialog" max-width="600px">
                  <template v-slot:activator="{ on }">


                    <v-container>
                      <v-row>
                        <v-col cols="12" md="4" xs="12" sm="12">
                            <v-btn large color="purple" dark class="mb-2" v-on="on">إضافة إحالة جديدة</v-btn>
                        </v-col>
                        <v-col cols="12" md="8" xs="12" sm="12">
                          <v-text-field
                            filled
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="بحث ..."
                            single-line
                            v-on:key.enter="getRefers"
                            hide-details></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <v-form
                          v-model="valid"
                          lazy-validation
                          ref="form"
                          id="new-form">
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ dialogTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-autocomplete v-if="refer.isedit == false || refer.isedit == undefined"
                                    required
                                    v-model="refer.patient"
                                    :items="mypatients"
                                    item-text="text"
                                    label="إسم المراجع"
                                    return-object
                                    >
                            </v-autocomplete>
                            <v-text-field v-else
                                    v-model="refer.patient_name"
                                    disabled
                                    readonly
                                    label="إسم المراجع"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                                    v-model="refer.hospital"
                                    required
                                    :rules="Rules('nameRules')"
                                    label="المستشفى"></v-text-field>
                          </v-col>

                        </v-row>
                          <v-row>
                              <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                          v-model="refer.disease"
                                          required
                                          :rules="Rules('nameRules')"
                                          label="المرض"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                          v-model="refer.diagnose"
                                          required
                                          :rules="Rules('nameRules')"
                                          label="التشخيص"></v-text-field>
                              </v-col>

                          </v-row>

                          <v-row>
                              <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                          v-model="refer.doctorname"
                                          required
                                          :rules="Rules('nameRules')"
                                          label="اسم الطبيب"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">

                                <v-menu offset-y>
                                  <template v-slot:activator="{ on }">
                                    <v-text-field aria-autocomplete="none"
                                                  v-on="on"
                                                  :rules="Rules('dateRules')"
                                                  required
                                                  v-model="refer.referdate"
                                                  class="purple-input"
                                                  label="تاريخ الإحالة"></v-text-field>
                                  </template>
                                  <v-date-picker dark v-model="refer.referdate" />
                                </v-menu>
                              </v-col>

                          </v-row>

                          <v-row>
                              <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                          v-model="refer.receivername"
                                          label="اسم المستلم"></v-text-field>
                              </v-col>


                          </v-row>


                      </v-container>

                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">إلغاء</v-btn>
                      <v-btn color="blue darken-1" form="new-form" @click="validateFunc" :disabled="!valid">حفظ</v-btn>
                    </v-card-actions>
                  </v-card>
                  </v-form>
                </v-dialog>



                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">قائمة دوائر الصحة</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12" xs="12">
                            <v-card>
                              <v-card-title>
                                    تعديل معلومات الإحالة
                              </v-card-title>
                              <v-card-subtitle>
                                يمكنك تعديل معلومات الإحالة و تغيير تفاصيل المستشفى
                              </v-card-subtitle>
                              <v-card-actions>
                                  <v-btn color="primary" dark @click="editRefers">
                                    تعديل
                                  </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">اغلاق</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>


            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>{{ item.id }}</td>
              <td>{{ item.patient.text }}</td>
              <td>{{ item.disease }}</td>
              <td>{{ item.diagnose }}</td>
              <td>{{ item.hospital }}</td>
              <td>{{ item.doctorname }}</td>
              <td>{{ item.receivername }}</td>
              <td>{{ item.referdate }}</td>
              <td>{{ item.addby }}</td>
              <td>{{ item.adddate }}</td>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                      primary
                      dark
                      center
                      @click="editRefers(item)">
              <v-icon
                      medium
              >
                mdi-pencil
              </v-icon>

              </v-btn>
              <v-btn
                      warning
                      dark
                      @click="deleteItem(item)">
              <v-icon
                      medium
              >
                mdi-delete
              </v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import {__HAS_PERM,FormHeader,__HTTP} from "@/utils/utils"
export default {
  computed: {
    mypatients() {
      return this.patients
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    newDialog (val) {
      val || this.close()
    },
  },
  methods: {
    Rules(type) {
      return this.$store.state.appRules[type];
    },
    getPatients() {
      __HTTP("?do=getmypatients",{},FormHeader,(res) => {
         res.map((i) => {
          this.patients.push({text: i.fullname, value: i.id});

        })
        this.getRefers();
      })
    },
    getRefers() {
      __HTTP("?do=getrefers",
        { 
          keyword: this.search
        },
        FormHeader,
        (res) => {
          this.isloading = false
          this.items = res;
      });
     
    },
    editRefers (item) {
       this.refer =
          {
              patient_name: item.patient_name,
              patientid: item.patientid,
              hospital: item.hospital,
              doctorname: item.doctorname,
              disease: item.disease,
              diagnose: item.diagnose,
              referdate: item.referdate,
              receivername: item.receivername,
              isedit: true,
              id: item.id,
              item: item
        }

      this.dialogTitle = "تعديل معلومات الإحالة"
      this.newDialog = true

    },

    deleteItem (item) {
      const index = this.items.indexOf(item)
      let c = confirm('Are you sure you want to delete this item?');
      if (c) {
        __HAS_PERM(27,this.$store.state.loggedUser.id,() => {
          __HTTP("?do=delete",{type: "refer",id: item.id},FormHeader,() => {
            this.items.splice(index, 1)
          })
        });
      }
    },
    close () {
      this.dialogTitle = 'إضافة إحالة جديدة';
      this.refer =
          {
              patientid: '',
              hospital: '',
              doctorname: '',
              disease: '',
              diagnose: '',
              referdate: '',
              receivername: '',
              isedit: false,
              patient_name: ''
        }
      this.newDialog = false
    },
    validateFunc() {
      //console.log("btnClicked")
      if (this.$refs.form.validate()) {
        this.save()
      }
    },
   

    save () {
      __HTTP("?do=newrefer",{ patient: this.refer.patient.value,
                disease: this.refer.disease,
                diagnose: this.refer.diagnose,
                hospital: this.refer.hospital,
                doctorname: this.refer.doctorname,
                referdate: this.refer.referdate,
                receivername: this.refer.receivername,
                isedit: this.refer.isedit ? true : false,
                id: this.refer.id},FormHeader,(res) => {
                     if (res.auth == true) {
          if (this.refer.isedit == false)
          this.items.push({
            patient: this.refer.patient.text,
            pid: this.refer.patient.value,
            disease: this.refer.disease,
            diagnose: this.refer.diagnose,
            hospital: this.refer.hospital,
            doctorname: this.refer.doctorname,
            referdate: this.refer.referdate,
            receivername: this.refer.receivername,
            addby: '-',
            adddate: res.adddate,
            id: res.id
          })
          else {

            var ind = this.items.findIndex(obj => parseInt(obj.id) == res.id);
            this.items.splice(ind,1,{
              patient: this.refer.patient.text,
              pid: this.refer.patient.value,
              disease: this.refer.disease,
              diagnose: this.refer.diagnose,
              hospital: this.refer.hospital,
              doctorname: this.refer.doctorname,
              referdate: this.refer.referdate,
              receivername: this.refer.receivername,
              addby: '-',
              adddate: res.adddate,
              id: res.id
            })


          }
          this.refer=
          {
              patientid: '',
              hospital: '',
              doctorname: '',
              disease: '',
              diagnose: '',
              referdate: '',
              receivername: '',
              isedit: false
        }
        this.dialogTitle = 'إضافة إحالة جديدة';
          this.newDialog = false
        }
      });
     
       
    },
  },
  created() {
     this.getPatients();
    },
  data: () => ({
    valid: true,
    dialogTitle: 'إضافة إحالة جديدة',
    search: '',
    patients: [],
    newDialog: false,
    isloading: true,
    loadingtext: "يرجى الانتظار جاري تحميل البيانات",
    dialog: false,
    toBeEdit: null,
      refer:
          {
              patient: null,
              patientid: '',
              hospital: '',
              doctorname: '',
              disease: '',
              diagnose: '',
              referdate: '',
              receivername: ''
        },
    headers: [
      {
        sortable: true,
        text: '#',
        value: 'id',
        align: 'right'
      },
      {
        sortable: true,
        text: 'اسم المراجع',
        value: 'patient_name',
        align: 'right'
      },
      {
        sortable: true,
        text: 'المرض',
        value: 'disease',
        align: 'right'
      },
      {
            sortable: true,
            text: 'التشخيص',
            value: 'diagnose',
            align: 'right'
      },
        {
            sortable: true,
            text: 'المستشفى',
            value: 'hospital',
            align: 'right'
        },

        {
            sortable: true,
            text: 'الطبيب',
            value: 'doctorname',
            align: 'right'
        },

        {
            sortable: true,
            text: 'تاريخ الاحالة',
            value: 'referdate',
            align: 'right'
        },
        {
            sortable: true,
            text: 'استلمت بواسطة',
            value: 'receivername',
            align: 'right'
        },
      {
        sortable: true,
        text: 'اضيفت بواسطة',
        value: 'addby',
        align: 'right'
      },
      {
        sortable: true,
        text: 'اضيفت بتاريخ',
        value: 'adddate',
        align: 'right'
      },
      { text: 'الادوات', value: 'action', sortable: false },
    ],
    items: [

    ]
  })
}
</script>
